import React, { Component } from 'react';
import ProjectPercent from '../sumTotal/proPercent';
import TransfiniteManage from './transfinite';
import ProPercentModal from './ProPercentModal';
import { saveParams } from '../../actions/noticeActions';
import { connect } from 'react-redux';

class ProPercent extends Component {
    state = {
        type: "percent",
        transfinite: false,
    }

    componentDidMount() {
        this.props.saveParams({
            investigationName: undefined,  
        });
    }

    showView = (row) => {
        this.setState({
            invId: row.investigationId
        }, () => {
            this.ProPercentModalRef.show(row)
        });
    }

    changeType = (type) => {
        this.setState({ type });
        if (type == "percent") {
            location.href = `./#/proPercent`;
        }
        if (type == "list") {
            location.href = `./#/invList`;
        }
    }

    showTransfinite = (transfinite) => {
        this.setState({ transfinite });
    }

    render() {
        const { invId = '', type, transfinite } = this.state;
        const { curRole } = sessionStorage;
        const { params = {} } = this.props;
        const { investigationName } = params;
        const isBO = curRole == "BO";
        const isPM = curRole == "PM";
        const isVP = curRole == "VP";
        const isFIN = curRole == "FIN";
        const isPML = curRole == "PML";
        return (
            <div className="full home">
                {
                    (isBO || isPM || isVP || isFIN || isPML) &&
                    <div className='change-btn' style={{ marginBottom: 30 }}>
                        <a className={type == "list" ? 'cur' : ''} onClick={() => this.changeType('list')} >项目列表</a>
                        <a className={type == "percent" ? 'cur' : ''} onClick={() => this.changeType('percent')} >项目完工百分比汇总</a>
                    </div>
                }
                {
                    !transfinite ?
                        <div className="content-2">
                            <ProjectPercent
                                type='pro'
                                invId={invId}
                                investigationName={investigationName}
                                showView={this.showView}
                                showTransfinite={value => this.showTransfinite(value)}
                            />
                        </div>
                    :
                        <TransfiniteManage showTransfinite={value => this.showTransfinite(value)} />
                }
                <ProPercentModal ref={el => this.ProPercentModalRef = el} />
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProPercent);


// WEBPACK FOOTER //
// ./src/components/investigation/ProPercent.js